export default __webpack_public_path__ + "static/media/Salah.5383ad73.webp";